require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./services-graphic-design-social-media-graphics.json") })
        }
      }, "path---services-graphic-design-social-media-graphics");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---services-graphic-design-social-media-graphics!./.cache/json/services-graphic-design-social-media-graphics.json
// module id = 745
// module chunks = 231608221292675